export type MarketingExperiment = {
  id: string;
  enabled: boolean;
  variants: readonly string[];
  goal: "lead_saved" | "proposal_accepted" | "fabrication_deposit_confirmed";
};
export type ExperimentExposure = {
  id: string;
  variant: string;
  exposedAt: string;
};
/** Owner-controlled registry. Empty means no split tests, tracking cookies or alternate UI. */
export const MARKETING_EXPERIMENTS: readonly MarketingExperiment[] = [];

export function experimentVariant(
  experiment: MarketingExperiment,
  visitorId: string,
): string | null {
  if (!experiment.enabled || !visitorId || experiment.variants.length < 2)
    return null;
  let hash = 2166136261;
  for (const char of `${experiment.id}:${visitorId}`)
    hash = Math.imul(hash ^ char.charCodeAt(0), 16777619) >>> 0;
  return experiment.variants[hash % experiment.variants.length];
}
export function validExperimentExposures(
  value: unknown,
  registry = MARKETING_EXPERIMENTS,
): ExperimentExposure[] {
  if (!Array.isArray(value)) return [];
  const seen = new Set<string>();
  return value.slice(0, 10).flatMap((item) => {
    const test = registry.find((t) => t.id === item?.id);
    if (
      !test ||
      seen.has(test.id) ||
      !test.variants.includes(item.variant) ||
      typeof item.exposedAt !== "string" ||
      !Number.isFinite(Date.parse(item.exposedAt))
    )
      return [];
    seen.add(test.id);
    return [{ id: test.id, variant: item.variant, exposedAt: item.exposedAt }];
  });
}
